module.exports = __webpack_public_path__ + "media/images/bga_logo_indexkep-f2eebcd64cd9a5a654a71d5e2cf6c75b.jpg";